import { updateCustomer } from "@/api/1c-api/customers"
import { getEntityById } from "@/api/amocrm-api/entities"
import { setContragentData } from "@/utilities/contragents"


const state = () => ({
    isLoading: true,
    errorText: ''
})

const getters = {
    isLoading: state => state.isLoading,
    errorText: state => state.errorText
}

const actions = {
    async update({commit, rootGetters}, {id, type}){
        commit('setLoading', true)
        const amoCfsByIds = rootGetters['amo/customFieldsByIds'];
        const users = rootGetters['accountData'].amoUsers
        const settings = rootGetters['settings/getDocflowSettings'];
        const features = rootGetters['features/getFeatures']
        const data = {}

        if (type == 1){
            try {
                const contact = await getEntityById({entitiesType: 'contacts', id})
                setContragentData({
                    type,
                    entity: contact,
                    orderFieldsSettings: settings.orderFields,
                    amoCfs: amoCfsByIds,
                    users: users,
                    features,
                    data
                })
            } catch (e){
                console.debug('Ошибка записи данных контакта', {e})
            }
        } else if (type == 3){
            try {
                const company = await getEntityById({entitiesType: 'companies', id})
                setContragentData({
                    type,
                    entity: company,
                    orderFieldsSettings: settings.orderFields,
                    amoCfs: amoCfsByIds,
                    users: users,
                    features,
                    data
                })
            } catch (e){
                console.debug('Ошибка записи данных компании', {e})
            }
        }

        try {
            const response = await updateCustomer(data)
            if (response.data?.error){
                commit('setError', response.data.error)
            }
        } catch (e){
            console.debug('Ошибка записи данных контрагента', {e})
        }

        commit('setLoading', false)
    }
}

const mutations = {
    setError: (state, text) => state.errorText = text,
    setLoading: (state, value) => state.isLoading = value
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

